/* motion.js — couche d'animations premium (GSAP + ScrollTrigger).
   Progressive enhancement : sans JS ou en reduced-motion, tout le contenu reste visible
   (les états initiaux cachés ne s'appliquent que sous html.has-motion, posé dans theme.liquid). */
(function () {
  'use strict';

  var root = document.documentElement;
  var hasMotion = root.classList.contains('has-motion');
  if (!hasMotion) return;

  if (!window.gsap || !window.ScrollTrigger) {
    root.classList.remove('has-motion');
    return;
  }

  var gsap = window.gsap;
  gsap.registerPlugin(window.ScrollTrigger);
  var ST = window.ScrollTrigger;
  var EASE = 'power3.out';

  /* ---------- 1. Header : drop-and-fade ---------- */
  function animateHeader() {
    var items = document.querySelectorAll('.header__logo, .header__nav > * , .header__icons > *');
    if (!items.length) return;
    gsap.fromTo(items,
      { y: -14, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, duration: 0.7, ease: EASE, stagger: 0.05, delay: 0.1, clearProps: 'transform' });
  }

  /* ---------- 2. Hero : rise séquencé net (sans flou ni zoom — retour utilisateur :
     tout scale sur le média ré-échantillonne la vidéo et donne un rendu flou) ---------- */
  function animateHero() {
    var hero = document.querySelector('[class*="hero--"]');
    if (!hero) return;

    var seq = hero.querySelectorAll('[data-hero]');
    if (seq.length) {
      gsap.fromTo(seq,
        { y: 26, autoAlpha: 0 },
        { y: 0, autoAlpha: 1, duration: 0.85, ease: EASE, stagger: 0.09, delay: 0.15, clearProps: 'transform' });
    }

    var card = hero.querySelector('.hero__card[data-hero-card]');
    if (card) {
      gsap.fromTo(card,
        { y: 36, autoAlpha: 0 },
        { y: 0, autoAlpha: 1, duration: 1.1, ease: EASE, delay: 0.35, clearProps: 'transform' });
      var badge = card.querySelector('.hero__badge');
      if (badge) {
        gsap.fromTo(badge,
          { scale: 0.7, autoAlpha: 0 },
          { scale: 1, autoAlpha: 1, duration: 0.6, ease: 'back.out(2.2)', delay: 1.1, clearProps: 'transform' });
      }
    }
  }

  /* ---------- 3. Stats : arc qui se dessine + dot pulsant + compteur ---------- */
  function animateStats() {
    document.querySelectorAll('[data-stats-arc]').forEach(function (section) {
      var stats = section.querySelectorAll('.sb__stat');
      if (!stats.length) return;

      var tl = gsap.timeline({
        scrollTrigger: { trigger: section, start: 'top 72%', once: true }
      });

      stats.forEach(function (stat, i) {
        var arc = stat.querySelector('.sb__arc-path');
        var dot = stat.querySelector('.sb__arc-dot');
        var num = stat.querySelector('.sb__num');
        var label = stat.querySelector('.sb__label');
        var at = i * 0.18;

        gsap.set(stat, { autoAlpha: 1 });
        if (arc) {
          var len = arc.getTotalLength();
          gsap.set(arc, { strokeDasharray: len, strokeDashoffset: len });
          tl.to(arc, { strokeDashoffset: 0, duration: 0.9, ease: 'power2.inOut' }, at);
        }
        if (dot) {
          tl.fromTo(dot, { scale: 0, transformOrigin: 'center' },
            { scale: 1, duration: 0.45, ease: 'back.out(3)', onComplete: function () { dot.classList.add('is-pulsing'); } }, at + 0.78);
        }
        if (num) {
          tl.fromTo(num, { autoAlpha: 0, y: 10 }, { autoAlpha: 1, y: 0, duration: 0.5, ease: EASE }, at + 0.55);
          var m = (num.getAttribute('data-count') || num.textContent).match(/\d+/);
          if (m && +m[0] > 0) {
            var target = +m[0];
            var tpl = num.textContent;
            var proxy = { v: 0 };
            tl.to(proxy, {
              v: target, duration: 0.9, ease: 'power1.out',
              onUpdate: function () { num.textContent = tpl.replace(m[0], Math.round(proxy.v)); }
            }, at + 0.55);
          }
        }
        if (label) {
          tl.fromTo(label, { autoAlpha: 0 }, { autoAlpha: 0.95, duration: 0.5 }, at + 0.85);
        }
      });
    });
  }

  /* ---------- 3b. Avis : cascade façon peaq — les cartes descendent au fil du scroll ---------- */
  function animateAvisCascade() {
    document.querySelectorAll('[data-avis-cascade]').forEach(function (section) {
      var cards = section.querySelectorAll('.tst__card');
      if (!cards.length) return;
      var OFFSETS = [-150, -290, -210, -340, -180, -260];
      var TILTS = [-3.5, 2.5, -2, 3.5, -2.5, 2];
      cards.forEach(function (card, i) {
        gsap.fromTo(card,
          { y: OFFSETS[i % OFFSETS.length], rotation: TILTS[i % TILTS.length], autoAlpha: 0 },
          {
            y: 0, rotation: 0, autoAlpha: 1, ease: 'none',
            scrollTrigger: { trigger: section, start: 'top 92%', end: 'center 52%', scrub: 0.6 }
          });
      });
    });
  }

  /* ---------- 4. Mots géants : remplissage corail piloté par le scroll ---------- */
  function animateWords() {
    document.querySelectorAll('[data-word-reveal]').forEach(function (section) {
      section.querySelectorAll('.wr__row').forEach(function (row) {
        var fill = row.querySelector('.wr__word-fill');
        var desc = row.querySelector('.wr__desc');
        if (fill) {
          gsap.fromTo(fill, { clipPath: 'inset(0 100% 0 0)' }, {
            clipPath: 'inset(0 0% 0 0)', ease: 'none',
            scrollTrigger: { trigger: row, start: 'top 78%', end: 'top 38%', scrub: 0.4 }
          });
        }
        if (desc) {
          gsap.fromTo(desc, { autoAlpha: 0, x: 18 }, {
            autoAlpha: 1, x: 0, duration: 0.7, ease: EASE,
            scrollTrigger: { trigger: row, start: 'top 62%', once: true }
          });
        }
      });
    });
  }

  /* ---------- 5. Vidéo scrubée au scroll (desktop uniquement) ---------- */
  function animateVideoScrub() {
    var isDesktop = window.matchMedia('(min-width: 900px) and (pointer: fine)').matches;
    document.querySelectorAll('[data-video-scrub]').forEach(function (section) {
      var video = section.querySelector('video.vs__media');
      var inner = section.querySelector('.vs__inner');
      if (!video) return;

      if (!isDesktop) return; // mobile : autoplay loop natif conservé

      video.removeAttribute('loop');
      video.removeAttribute('autoplay');
      video.pause();
      video.preload = 'auto';

      var targetTime = 0;
      var ready = false;
      function onMeta() { ready = true; }
      if (video.readyState >= 1) onMeta();
      else video.addEventListener('loadedmetadata', onMeta, { once: true });

      // lissage : on tend vers targetTime à chaque tick pour éviter les sauts de keyframe
      var tick = function () {
        if (!ready || !video.duration) return;
        var delta = targetTime - video.currentTime;
        if (Math.abs(delta) > 0.035) {
          video.currentTime = video.currentTime + delta * 0.22;
        }
      };
      gsap.ticker.add(tick);

      ST.create({
        trigger: section,
        start: 'top top',
        end: '+=130%',
        pin: true,
        scrub: true,
        anticipatePin: 1,
        onUpdate: function (self) {
          if (video.duration) targetTime = self.progress * (video.duration - 0.05);
        }
      });

      if (inner) {
        gsap.fromTo(inner.children,
          { y: 34, autoAlpha: 0 },
          {
            y: 0, autoAlpha: 1, stagger: 0.12, ease: 'none',
            scrollTrigger: { trigger: section, start: 'top top', end: '+=55%', scrub: true }
          });
      }
    });
  }

  /* ---------- 6. Page expérience cinéma (recette Jewel Scape adaptée vente) ----------
     Scroll natif + scène sticky (CSS). Desktop pointer fine : les 2 vidéos sont scrubées.
     Mobile : autoplay loop + crossfade. Tous les actes/panneaux dérivent d'un seul progress lissé. */
  function animateCinema() {
    document.querySelectorAll('[data-cinema]').forEach(function (cx) {
      var stage = cx.querySelector('.cx__stage');
      if (!stage) return;
      var vA = cx.querySelector('.cx__video--a');
      var vB = cx.querySelector('.cx__video--b');
      var act1 = cx.querySelector('[data-cx-act="1"]');
      var act2 = cx.querySelector('[data-cx-act="2"]');
      var act3 = cx.querySelector('[data-cx-act="3"]');
      var pan1 = cx.querySelector('[data-cx-panel="1"]');
      var pan2 = cx.querySelector('[data-cx-panel="2"]');
      var bar = cx.querySelector('[data-cx-bar]');
      var rail = cx.querySelector('[data-cx-rail]');
      var scrubVideo = window.matchMedia('(min-width: 900px) and (pointer: fine)').matches;

      if (scrubVideo) {
        [vA, vB].forEach(function (v) {
          if (!v) return;
          v.removeAttribute('autoplay'); v.removeAttribute('loop');
          v.pause(); v.preload = 'auto';
        });
      }

      var prog = 0, smooth = 0;
      ST.create({
        trigger: cx, start: 'top top', end: 'bottom bottom', scrub: 0.3,
        onUpdate: function (self) { prog = self.progress; }
      });

      function seg(p, a, b) { return Math.min(1, Math.max(0, (p - a) / (b - a))); }
      function fade(el, o, y, x) {
        if (!el) return;
        o = Math.min(1, Math.max(0, o));
        el.style.opacity = String(o);
        // les panneaux sont ancrés par un transform CSS (centrage) : on anime leur carte interne
        var target = el.hasAttribute('data-cx-panel') ? (el.querySelector('.cx__card') || el) : el;
        target.style.transform = 'translate(' + (x || 0) + 'px,' + (y || 0) + 'px)';
        el.classList.toggle('is-live', o > 0.6);
      }
      function scrubTo(v, p01) {
        if (!v || !v.duration || v.seeking) return;
        var t = p01 * (v.duration - 0.05);
        if (Math.abs(t - v.currentTime) > 0.035) v.currentTime += (t - v.currentTime) * 0.18;
      }

      var tick = function () {
        smooth += (prog - smooth) * 0.12;
        var p = smooth;

        if (scrubVideo) { scrubTo(vA, seg(p, 0, 0.5)); scrubTo(vB, seg(p, 0.5, 1)); }
        var xf = seg(p, 0.46, 0.56);
        if (vA) vA.style.opacity = String(1 - xf);
        if (vB) {
          vB.style.opacity = String(xf);
          if (!scrubVideo && xf > 0 && vB.paused) { try { vB.play(); } catch (e) {} }
        }

        var out1 = seg(p, 0.10, 0.18);
        fade(act1, 1 - out1, -46 * out1);
        fade(act2, seg(p, 0.20, 0.27) - seg(p, 0.36, 0.42), 28 * (1 - seg(p, 0.20, 0.27)) - 40 * seg(p, 0.36, 0.42));
        fade(pan1, seg(p, 0.40, 0.46) - seg(p, 0.52, 0.58), 0, 64 * (1 - seg(p, 0.40, 0.46)));
        fade(act3, seg(p, 0.58, 0.65) - seg(p, 0.80, 0.86), 28 * (1 - seg(p, 0.58, 0.65)) - 40 * seg(p, 0.80, 0.86));
        fade(pan2, seg(p, 0.88, 0.94), 44 * (1 - seg(p, 0.88, 0.94)));
        if (bar) bar.classList.toggle('is-on', p > 0.32 && p < 0.995);
        if (rail) rail.style.height = (p * 100).toFixed(1) + '%';
      };

      // éditeur : ne pas empiler les tickers à chaque rechargement de section
      if (cx.__cxTick) gsap.ticker.remove(cx.__cxTick);
      cx.__cxTick = tick;
      gsap.ticker.add(tick);
    });
  }

  /* ---------- Init ---------- */
  function init() {
    try {
      root.setAttribute('data-motion-ran', '1');
      animateHeader();
      animateHero();
      animateAvisCascade();
      // ordre du document : le pin (video scrub) AVANT les sections situées plus bas,
      // sinon leurs triggers ne compensent pas la distance épinglée
      animateVideoScrub();
      animateStats();
      animateWords();
      animateCinema();
      ST.sort();
      ST.refresh();
    } catch (err) {
      // au moindre pépin : on rend tout visible immédiatement
      root.classList.add('motion-failed');
      if (window.console && console.error) console.error('[motion] désactivé :', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Éditeur de thème Shopify : ré-initialiser proprement à chaque rechargement de section
  document.addEventListener('shopify:section:load', function () {
    ST.getAll().forEach(function (t) { t.kill(); });
    init();
  });
})();
